/** Landing-page marketing links and early-access counters (update filledSlots manually). */

export const CALENDLY_URL =
  process.env.REACT_APP_CALENDLY_URL?.trim() ||
  "https://calendly.com/yashwantajeet-zoniq/zoniq-event-os-demo";

export const INSTAGRAM_URL =
  process.env.REACT_APP_INSTAGRAM_URL?.trim() || "https://www.instagram.com/zoniq.in/";

export const LINKEDIN_URL =
  process.env.REACT_APP_LINKEDIN_URL?.trim() || "https://in.linkedin.com/company/zoniq-in";

export const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL?.trim() || "";

export const EARLY_ACCESS = {
  totalSlots: 5,
  /** Manually bump when a partner is onboarded. */
  filledSlots: 2,
} as const;

export function remainingEarlyAccessSlots(): number {
  return Math.max(0, EARLY_ACCESS.totalSlots - EARLY_ACCESS.filledSlots);
}
